'use client'
import React from 'react'

export interface TabsProps {
    children: React.ReactNode
}

export const Tabs = ({ children }: TabsProps) => {
    return (
        <div className="tabs flex w-full horizontal">
            {children}
            <span className="tabs__filler bg-shade-opacity-100 border-b border-shade-opacity-100 flex-grow h-auto" />
        </div>
    )
}
